<div class="content">
  @let hasSidebar = !(healthCheckFail$ | async);
  <cosmos-header [isSidebarVisible]="hasSidebar"></cosmos-header>
  @for (banner of bannerTopics(); track banner) {
    <coin-c-maintenance-banner
      [class.small-width]="!(sideBarCollapsed$ | async)"
      [class.full-width]="sideBarCollapsed$ | async"
      [topic]="banner"
      (close)="closeBanner(banner)"></coin-c-maintenance-banner>
  }
  <main
    [class.full-width]="!hasSidebar"
    [class.banner-visible]="bannerTopics()?.length > 0">
    <router-outlet></router-outlet>
    @if (hasSidebar) {
      <cosmos-sidebar
        role="navigation"
        [isEnabled]="isSidebarEnabled$ | async"></cosmos-sidebar>
    }
  </main>
  <footer></footer>
</div>
